const classPrefix = 'hc-data-table';

/**
 * Collection of class names inside DataTable component.
 */
export const DataTableClassNames = {
  Action: `${classPrefix}-action`,
  ActionChildren: `${classPrefix}-action-children`,
  CellAction: `${classPrefix}-cell-action`,
} as const;

export const DataTableVariableNames = {
  BackgroundColor: '--data-table-background-color',
  BodyBorderColor: '--data-table-body-border-color',
  HeaderBorderColor: '--data-table-header-border-color',
  HeaderBackgroundColor: '--data-table-header-background-color',
  HeaderTextColor: '--data-table-header-text-color',
  BorderRadius: '--data-table-border-radius',
  BorderWidth: '--data-table-border-width',
  OutlineWidth: '--data-table-outline-width',
  OutlineColor: '--data-table-outline-color',
  ShadowWidth: '--data-table-shadow-width',
  ShadowColor: '--data-table-shadow-color',
  FixedColumnWidth: '--data-table-fixed-column-width',
  FixedActionColumnWidth: '--data-table-fixed-action-column-width',
  FilterColor: '--data-table-filter-color',
} as const;
